import * as React from 'react';

import { NavToolBar } from '..';
import { NavDrawer } from '..';

import './headerContainer.css'

export interface IHeaderProps {
  activeLink: string;
}

export interface IHeaderState {
  activeLinkName: string,
  isDrawerOpen: boolean
}

export default class IHeader extends React.Component<IHeaderProps, IHeaderState> {
  constructor(props: IHeaderProps) {
    super(props);

    this.state = {
      activeLinkName: '',
      isDrawerOpen: false
    }
  }

  public toggleDrawer = () => {
    console.log('toggle');
    this.setState({
      isDrawerOpen: !this.state.isDrawerOpen
    })
  }

  public render() {
    return (
      <div>
        <NavDrawer isNavBarVisible={this.state.isDrawerOpen} toggleDrawer={ this.toggleDrawer } />
        <NavToolBar isDrawerOpen={this.state.isDrawerOpen} toggleDrawer={this.toggleDrawer}/>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/bundles/common/components/headerContainer/headerContainer.tsx